import { render, staticRenderFns } from "./InternalPluginList.vue?vue&type=template&id=6997848a&scoped=true"
import script from "./InternalPluginList.vue?vue&type=script&lang=js"
export * from "./InternalPluginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997848a",
  null
  
)

export default component.exports